import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { useStationeryTemplateCategoryTranslations } from '@apps/card/hooks/useStationeryTemplateCategoryTranslations';
import { useTranslation } from '@shared/core';

const Slash = () => <Box as="span">/</Box>;

type BreadcrumbSectionProps = Readonly<{
  category: StationeryTemplateCategoryEnum;
}>;

export const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({ category }) => {
  const { tq } = useTranslation('stationery');
  const getCategoryName = useStationeryTemplateCategoryTranslations('designsGalleryPdpBreadcrumbCategory');

  if (category !== StationeryTemplateCategoryEnum.saveTheDate) {
    return null;
  }

  const categoryName = getCategoryName(category);

  return (
    <Box
      width="100%"
      paddingLeft={{ _: 6, sm2: 8 }}
      paddingRight={{ _: 4, sm2: 6 }}
      paddingTop={{ _: 6, md: 8 }}
    >
      <Flex
        typographyVariant="hed2"
        alignItems="center"
        gap={5}
      >
        <Box
          as="a"
          href="https://withjoy.com/"
        >
          {tq`Home`}
        </Box>
        <Slash />
        <Box
          as="span"
          color="mono10"
          cursor="default"
        >
          {categoryName}
        </Box>
      </Flex>
    </Box>
  );
};
